import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.89 4.65H9.05a.74.74 0 0 0-.75.75v7.78a.75.75 0 0 0 .75.75h2.84a2 2 0 0 0 2-2V6.7a2 2 0 0 0-2-2.05Zm-.16 6.63h-1.29V10h1.29Zm0-2.69h-1.29v-1.3h1.29ZM5.62 2.05H4.11A2.05 2.05 0 0 0 2.06 4.1v7.78a2.05 2.05 0 0 0 2.05 2h2.81a.75.75 0 0 0 .75-.75V4.1a2.05 2.05 0 0 0-2.05-2.05Zm-.11 9.23H4.22V10h1.29Zm0-2.69H4.22v-1.3h1.29Zm0-2.68H4.22v-1.3h1.29Z';
const draw24px =
  'M18,7.25H13.62a.76.76,0,0,0-.75.75V20a.76.76,0,0,0,.75.75H18A2.76,2.76,0,0,0,20.75,18V10A2.75,2.75,0,0,0,18,7.25Zm-.24,9.83h-2v-2h2Zm0-4.16h-2v-2h2ZM8.34,3.25H6A2.75,2.75,0,0,0,3.25,6V18A2.75,2.75,0,0,0,6,20.75h4.34a.76.76,0,0,0,.75-.75V6A2.75,2.75,0,0,0,8.34,3.25ZM8.17,17.08h-2v-2h2Zm0-4.16h-2v-2h2Zm0-4.13h-2v-2h2Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BuildingsFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'buildingsFilled')) as IconWithRender;

BuildingsFilledIcon.displayName = 'BuildingsFilledIcon';
BuildingsFilledIcon.propTypes = Icon.propTypes;
BuildingsFilledIcon.renderIcon = (props) => <BuildingsFilledIcon {...props} />;
export default BuildingsFilledIcon;
